

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface StockUpdateHistoryParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface StockUpdateHistory {

    productName: any;
    category: string;
    batchNo: string;
    expDate: any;
    adjustmentDescription: string;
    adjustmentType: string;
    previousData: any;
    newData: any;
    doneBy: any;
    datetime: any;
    
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: StockUpdateHistoryParameter[];
    links?: any;
}

export abstract class StockUpdateHistoryData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<StockUpdateHistory[]>;
  abstract create(url: string,data: StockUpdateHistory): Observable<any>;
  abstract update(url: string,data: StockUpdateHistory): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract searchForMultiBranch(url: string,data:any): Observable<any>;
}
